import Thermometer from './Thermometer';
import { ThermometerBox } from './Thermometer.style';
import ThermometerImage from './ThermometerImage';

export default Thermometer;
export { ThermometerBox, ThermometerImage };
